import { render, staticRenderFns } from "./LegalBillingWelcome.vue?vue&type=template&id=397a3b75&scoped=true"
import script from "./LegalBillingWelcome.vue?vue&type=script&lang=js"
export * from "./LegalBillingWelcome.vue?vue&type=script&lang=js"
import style0 from "./LegalBillingWelcome.vue?vue&type=style&index=0&id=397a3b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a3b75",
  null
  
)

export default component.exports